import { css } from '@emotion/react';
import { IonBadge, IonText } from '@ionic/react';
import * as commonCss from '../../styles/common';
import React from 'react';

interface PillProps {
  label: string;
  value: string;
  valueColor?: string;
}

export const Pill: React.FC<PillProps> = ({ label, value, valueColor = 'light' }) => {
  const pillCss = {
    outerBadge: [
      css({
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        paddingLeft: '.5rem',
        paddingRight: '.5rem',
        paddingTop: '.3rem',
        paddingBottom: '.3rem',
        margin: '4px 0',
        backgroundColor: 'rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.12)', // use text color, but fallback to black
        borderRadius: '1rem',
        cursor: 'default',
      }),
    ],
    labelText: [
      commonCss.bold,
      css({
        paddingLeft: '.5rem',
        alignContent: 'center',
      }),
    ],
    innerBadge: [
      commonCss.smallText,
      css({
        color: valueColor,
        backgroundColor: 'white',
      }),
    ],
  };

  return (
    <IonBadge css={pillCss.outerBadge}>
      <IonText color="light" css={pillCss.labelText}>
        {label}
      </IonText>
      <IonBadge css={pillCss.innerBadge} mode="ios">
        {value}
      </IonBadge>
    </IonBadge>
  );
};
